<template>
    <div class="login-wrap">
        <div class="ms-login">
            <el-form :model="loginForm" status-icon :rules="$rules" ref="loginForm" label-width="0px"
                     class="demo-ruleForm">
                <div class="ms-title">EASTPROFIT</div>
                <el-form-item prop="userName">
                    <el-input v-model="loginForm.userName" placeholder="Input LoginName" suffix-icon="el-icon-fa-user"
                              @keyup.enter.native="submitForm('loginForm')">
                        <template slot="prepend">LoginName</template>
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input type="password" placeholder="Input Password" v-model="loginForm.password"
                              suffix-icon="el-icon-fa-lock" @keyup.enter.native="submitForm('loginForm')">
                        <template slot="prepend">&nbsp;Password &nbsp; </template>
                    </el-input>
                </el-form-item>
                <el-form-item prop="captcha">
                    <el-input placeholder="Input verification code" prefix-icon="el-icon-fa-picture-o" v-model="loginForm.captcha"
                              @keyup.enter.native="submitForm('loginForm')">
                        <template slot="append">
                            <img :src="captcha" @click="refreshCaptcha" class="append-img" title="Click to refresh verification code">
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item prop="rememberMe">
                    <el-checkbox v-model="loginForm.rememberMe">Remember me</el-checkbox>
                </el-form-item>
                <div class="login-btn">
                    <el-button type="primary" @click="submitForm('loginForm')">Login</el-button>
                </div>
            </el-form>
          <el-row>
            <div style="width:300px;margin:0 auto; padding:20px 0;">
              <a href="http://beian.miit.gov.cn/" target="_blank"><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">沪ICP备18040333号-1©
                <span>{{year}}</span>
              </p>
              </a>
            </div>
          </el-row>
          <el-row>
            <div style="width:300px;margin:0 auto; padding:20px 0;">
              <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402005578" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
                <img src="${base!}/assets/platform/img/batb.png" style="float:left;"/>
                <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">沪公网安备 31010402005578号</p>
              </a>
            </div>
          </el-row>
        </div>


    </div>
</template>

<script>
    import {mapState, mapGetters, mapMutations} from "vuex";

    export default {
        data: function () {
            return {
                captcha: baseUrl + "/captcha?length=4&" + Math.random(),
                loginForm: {
                    userName: "",
                    password: "",
                    captcha: "",
                    rememberMe: true
                }
            };
        },
        mounted(){
          //this.getCookie();
        },
        computed: {
            ...mapState({
                loginUser: state => state.loginUser,
                loginid :state => state.loginid
            }),

        },
        created() {
          this.loginForm.userName = this.loginid;
          if (this.loginUser.id) {
              this.$router.push({path: "/dashboard"});
          }
        },
        methods: {
            ...mapMutations(["save", "remove"]),
            refreshCaptcha() {
                this.captcha = baseUrl + "/captcha?length=4&" + Math.random();
            },
            submitForm(formName) {
                let that = this;
                let remlfag = "";
                if(this.loginForm.rememberMe)
                    remlfag = "true";
                else
                    remlfag = "false";
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.$api.User.login(this.loginForm, data => {
                          let loginUser = data.loginUser;
                          loginUser.roles = data.roles;
                          loginUser.permissions = data.permissions;
                          loginUser.rememberMe = that.loginForm.rememberMe;
                          that.save(loginUser);
                          //that.setCookie(that.loginForm.userName,that.loginForm.password,7,remlfag);
                            this.$router.push({path: "/dashboard"});
                        }, error => {
                            this.$message.error(error);
                            this.refreshCaptcha();
                        });
                    } else {
                        return false;
                    }
                });
            },

            setCookie(c_name, c_pwd, exdays, remeberFlag) {
              var exdate = new Date(); //获取时间
              exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
              //字符串拼接cookie
              window.document.cookie = "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
              window.document.cookie = "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
              window.document.cookie = "remeberFlag" + "=" + remeberFlag + ";path=/;expires=" + exdate.toGMTString();
            },

            //读取cookie
            getCookie: function() {
              if (document.cookie.length > 0) {
                var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
                for (var i = 0; i < arr.length; i++) {
                  var arr2 = arr[i].split('='); //再次切割
                  //判断查找相对应的值
                  if (arr2[0] == 'userName') {
                    this.loginForm.userName = arr2[1]; //保存到保存数据的地方
                  } else if (arr2[0] == 'userPwd') {
                    this.loginForm.password = arr2[1];
                  }
                }
              }
            }

        }
    };
</script>

<style scoped>
    .login-wrap {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #f5f7f9;
        background-image: url(../assets/images/background.png);
        -moz-background-size: 100% 100%;
        background-size: 100% 100%;
    }

    .append-img {
        height: 39px;
        border-radius: 0 4px 4px 0;
        cursor: pointer;
        margin-left: -20px;
        margin-right: -20px;
        margin-bottom: -5px;
    }

    .ms-title {
        font-family: -webkit-pictograph;
        text-align: center;
        font-size: 30px;
        color: #018abd;
        padding-bottom: 10px;
    }

    .ms-login {
        position: absolute;
        left: 50%;
        top: 45%;
        width: 300px;
        height: 300px;
        margin: -150px 0 0 -190px;
        padding: 40px;
        border-radius: 5px;
        background: #fff;
    }

    .login-btn {
        text-align: center;
    }

    .login-btn button {
        width: 100%;
        height: 36px;
    }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue